<aumico-table [data]="checklists" [options]="options" [delegate]="this" [filterSubject]="filterSubject"> </aumico-table>
